import React from 'react'
import { PANELBLUE } from '@doseme/cohesive-ui'

const formStyle: React.CSSProperties = {
  borderTop: `5px solid ${PANELBLUE}`
}

interface IProps {
  handleSubmit?: (evt: React.FormEvent<HTMLFormElement>) => Promise<void>
}

const StyledForm: React.FC<IProps> = ({ children, handleSubmit }) => {
  return (
    <form
      style={formStyle}
      className='w-100 bg-white p-4'
      onSubmit={handleSubmit}
    >
      {children}
    </form>
  )
}

export {
  StyledForm
}
